var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-modal',{attrs:{"show-zoom":"","width":"1200","height":"800","title":'扩展枚举：'+_vm.extra.title},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c(_vm.component,{key:_vm.key,tag:"component",attrs:{"name":_vm.extra.name}})]},proxy:true}]),model:{value:(_vm.modelShow),callback:function ($$v) {_vm.modelShow=$$v},expression:"modelShow"}})
}
var staticRenderFns = []

export { render, staticRenderFns }